import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { Panel } from "primereact/panel";
import { useEffect, useState } from "react";
import CardSeplag from "../../../components/CardSeplag";
import { printToast } from "../../../config/global";
import { useSelector, useDispatch } from "react-redux";
import {
  alterarPerfilUsuario,
  buscarPerfisdeAcesso,
  listarPerfilSitemaLogado,
  buscarVinculoAndPerfil,
  removerPerfilUsuario,
} from "../../../service/seguranca/usuario";

const Perfil = ({ idenPessoa }) => {
  const [vinculos, setVinculos] = useState([]);
  const [perfis, setPerfis] = useState([]);
  const [perfilSelecionado, setPerfilSelecionado] = useState([]);
  const user = useSelector((state) => state.userReducer.user);

  useEffect(() => {
    if (idenPessoa) {
      buscarVinculoAndPerfil(idenPessoa).then((res) => {
        setVinculos(res);
      });

      listarPerfilSitemaLogado().then((res) => {
        setPerfis(res);
      });
    }
  }, []);

  const alterarPerfil = () => {
    let jsonVinculoPerfil = [];
    if (vinculos.length > 0) {
      vinculos.forEach((e) => {
        jsonVinculoPerfil.push({ idenVinculo: e.idenVinculo, idenPerfilAcesso: perfilSelecionado.id });
      });

      const response = {
        contaAcessoId: idenPessoa,
        perfilVinculoVo: [...jsonVinculoPerfil],
      };

      return alterarPerfilUsuario(response).then((res) => {
        buscarVinculoAndPerfil(idenPessoa).then((resVinculos) => {
          setVinculos(resVinculos);
        });
        printToast({ summary: "Sucesso", detail: "Perfil alterado com sucesso" });
      });
    }

    printToast({ severity: "error", detail: "Usuario não possui vinculo" });
  };

  const removerPerfil = () => {
    let listaPerfilVinculo = [];
    const perfilAcesso = [];
    vinculos.forEach((e) => {
      perfilAcesso.push(e.perfil[0].perfilAcesso);
      listaPerfilVinculo.push(e.perfil[0].idenPerfilVinculo);
    });

    removerPerfilUsuario({ listaPerfilVinculo, perfilAcesso }).then((res) => {
      buscarVinculoAndPerfil(idenPessoa).then((resVinculos) => {
        setVinculos(resVinculos);
      });
      printToast({ summary: "Sucesso", detail: "Perfil removido com sucesso" });
    });
  };

  const columnNomePerfilAcessoTemplate = (node, column) => {
    let nomePerfilAcesso =
      node.perfil[0] && node.perfil[0].perfilAcesso.nomePerfilAcesso
        ? node.perfil[0].perfilAcesso.nomePerfilAcesso
        : "";
    return (
      <span>
        <p>{nomePerfilAcesso}</p>
      </span>
    );
  };

  const columnDescPerfilAcessoTemplate = (node, column) => {
    let descPerfilAcesso =
      node.perfil[0] &&
      node.perfil[0].perfilAcesso.autorizacoes[0] &&
      node.perfil[0].perfilAcesso.autorizacoes[0].data.nomeExibir
        ? node.perfil[0].perfilAcesso.autorizacoes[0].data.nomeExibir
        : "";
    return (
      <span>
        <p>{descPerfilAcesso}</p>
      </span>
    );
  };

  return (
    <>
      <CardSeplag title="Perfil de Acesso">
        <Panel header="Perfis">
          <div className="field">
            <Dropdown
              emptyMessage="Dados não encontrados"
              options={perfis}
              value={perfilSelecionado}
              onChange={(e) => setPerfilSelecionado(e.value)}
              optionLabel="nomePerfilAcesso"
              filter
              showClear
              filterBy="nomePerfilAcesso"
              placeholder="Selecione um Perfil"
              className=" col-12"
            />
          </div>
        </Panel>
        <br />
        <Panel header="Vínculos do Usuário">
          <DataTable
            value={vinculos}
            responsiveLayout="scroll"
            dataKey="idenVinculo"
            emptyMessage="Dados não encontrados"
          >
            <Column field="numrVinculo" header="Nº"></Column>
            <Column field="orgao.descOrgao" header="Órgão"></Column>
            <Column field="unidade.descUnidade" header="Unidade"></Column>
            <Column field="tipoVinculo.descTipoVinculo" header="Tipo"></Column>
            <Column field="statVinculo" header="Status"></Column>
            <Column body={columnNomePerfilAcessoTemplate} field="perfil.nomePerfilAcesso" header="Nome"></Column>
            <Column
              body={columnDescPerfilAcessoTemplate}
              field="perfil.autorizacoes"
              header="Descrição do Perfil"
            ></Column>
          </DataTable>
        </Panel>

        <br />
        <br />
        <div className="p-fluid grid">
          <div className="field col-12 md:col-8 ">&nbsp;</div>
          <div className="field col-12 md:col-2 ">
            <Button
              label="Aplicar"
              className="p-button-success"
              disabled={perfilSelecionado == null}
              onClick={alterarPerfil}
            />
          </div>
          <div className="field col-12 md:col-2 ">
            <Button label="Remover" className="p-button-danger" onClick={removerPerfil} />
          </div>
        </div>
      </CardSeplag>
    </>
  );
};

export default Perfil;
